import { NavLink } from 'react-router-dom';
import sam4 from '../../assets/sam4.webp';
import styles from './ChatSection.module.css';

const ChatSection = () => {
  return (
    <section className={styles.chatSection}>
      <div className={styles.imageContainer}>
        <img src={sam4} alt="Chat with me" className={styles.image} />
      </div>
      <div className={styles.textContainer}>
        <h2 className={styles.heading}>chat with me</h2>
        <p className={styles.paragraph}>
          General inquiries, partnership requests, or fan mail?
          Leave your information and Samantha will be sure to read it and send a reply!
        </p>
        <NavLink to="/contact" className={styles.button}>
          Dear Sam...
        </NavLink>
      </div>
    </section>
  );
};

export default ChatSection;
